<div>
  <!-- Left Sidebar -->
  <aside id="leftsidebar" class="sidebar" (mouseenter)="mouseHover($event)" (mouseleave)="mouseOut($event)">
    <!-- Menu -->
    <div class="menu">
      <ul class="list"
        [ngStyle]="{'position' : 'relative', 'max-height' : listMaxHeight+'px', 'max-width' : listMaxWidth+'px'}"
        [perfectScrollbar]>
        <li class="sidebar-user-panel">
          <div class="user-panel">
            <span class="material-icons">person</span>
          </div>
          <div class="profile-usertitle">
            <div class="sidebar-userpic-name">{{userFullName}} </div>
            <div class="profile-usertitle-job ">{{roleNames}} </div>
          </div>
        </li>
        <!-- Top Most level menu -->
        <ng-container *ngIf="sidebarItems.length > 0">
          <li [class.active]="showMenu === sidebarItem.moduleName && sidebarItem.submenu.length != 0" (click)="closeMenu(sidebarItem.class)"
            *ngFor="let sidebarItem of sidebarItems" [routerLinkActive]="sidebarItem.submenu.length != 0 ? '' : 'active'">
            <div class="header" *ngIf="sidebarItem.groupTitle === true">{{sidebarItem.title}}</div>
            <a [routerLink]="sidebarItem.class === '' ? [sidebarItem.path] : null" *ngIf="!sidebarItem.groupTitle;"
              [ngClass]="[sidebarItem.class]" (click)="callMenuToggle($event, sidebarItem.moduleName)" class="menu-top">
              <i [ngClass]="[sidebarItem.iconType]">{{sidebarItem.icon}}</i>
              <span class="hide-menu">{{sidebarItem.title}}
              </span>
              <span *ngIf="sidebarItem.badge != '' " [ngClass]="[sidebarItem.badgeClass]">{{sidebarItem.badge}}</span>
            </a>
            <!-- First level menu -->
            <ul class="ml-menu" *ngIf="sidebarItem.submenu.length > 0">
              <li [ngClass]="showSubMenu === sidebarSubItem.moduleName? 'activeSub':''"
                *ngFor="let sidebarSubItem of sidebarItem.submenu"
                [routerLinkActive]="sidebarSubItem.submenu.length > 0 ? '' : 'active'">
                <a [routerLink]="sidebarSubItem.submenu.length > 0 ? null : [sidebarSubItem.path]"
                  (click)="callSubMenuToggle($event,sidebarSubItem.moduleName)" [ngClass]="[sidebarSubItem.class]">
                  {{sidebarSubItem.title}}
                </a>
                <!-- Second level menu -->
                <ul class="ml-menu-2" *ngIf="sidebarSubItem.submenu.length > 0">
                  <li *ngFor="let sidebarSubsubItem of sidebarSubItem.submenu"
                    [ngClass]="showSubSubMenu === sidebarSubsubItem.moduleName? 'activeSubSub':''"
                    [routerLinkActive]="sidebarSubsubItem.submenu.length > 0 ? '' : 'active'">
                    <a [routerLink]="sidebarSubsubItem.submenu.length > 0 ? null : [sidebarSubsubItem.path]"
                      [ngClass]="[sidebarSubsubItem.class]">
                      {{sidebarSubsubItem.title}}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ng-container>
        <li *ngIf="isAdmin">
          <a target="_blank" [href]="customPublicInterface ? '/assets/documentation/manual-de-utilizare-administrare-425685987-custom.pdf' : '/assets/documentation/manual-de-utilizare-administrare-425685987.pdf'" style="cursor: pointer;">
            <i class="material-icons-two-tone">help</i>
            <span class="hide-menu">Manual de utilizare Admin</span>
          </a>
        </li>
        <li>
          <a href="/" style="cursor: pointer;">
            <i class="material-icons-two-tone">star_outline</i>
            <span class="hide-menu">Prima pagina</span>
          </a>
        </li>
        <li>
          <a (click)="logOut()"style="cursor: pointer;">
            <i class="material-icons-two-tone">power_settings_new</i>
            <span class="hide-menu">Logout</span>
          </a>
        </li>
      </ul>
      <div class="m-b-15">
        <div class="footer-logo">
          <a target="_blank" href="http://gamait.ro/"><img src="/assets/images/logo_GAMAIT wihite.png" alt="logo GAMAIT"/></a>
        </div>
        <div class="version">
          <span class="m-r-10">v{{ version }}</span> {{ versionDate }}
        </div>
      </div>
    </div>
    <!-- #Menu -->
  </aside>
  <!-- #END# Left Sidebar -->
</div>
